<template>
  <div>
    <p v-if="document.data && document.data.veryImportantErrors" class="text-danger font-larger font-weight-bold">
      {{ document.data.veryImportantErrors }}
    </p>

    <w-radio-list class="mt-3" :model="schema.sendByEmail" :values="sendByEmailValues" />

    <w-input class="mt-3" :model="schema.epuapAddress" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { formMixin } from '@/mixins/form';

// @vuese
// Modal podpisywania  dokumentu podpisem kwalifikowanym
// @group ActionData
export default {
  mixins: [formMixin],
  props: {
    // schema akcji
    schema: { type: Object, required: true }
  },
  data() {
    return {
      sendByEmailValues: [
        { value: true, text: 'w postaci elektronicznej' },
        { value: false, text: 'w postaci papierowej' }
      ]
    };
  },
  computed: {
    ...mapState({
      document: state => state.document.data
    })
  }
};
</script>
